import { APINodeClient } from './apiNodeCore';

const api = new APINodeClient();


export const insertHotelApi = async (response: any) => {
  return api.create('/hotel/add-new-hotel',response);
};




export const updateHotelApi = async (response: any) => {
  return api.create('/hotel/update-hotel',response);
};


export const deleteHotelDataApi = async (response: any) => {
  return api.create('/hotel/delete-hotel-data',response);
};



export const getHotelApi = async () => {
  return api.create('/hotel/get-hotel');
};
